
import { createContext } from "react";



const layoutContext = createContext(null)

export default layoutContext